export default __webpack_public_path__ + "static/media/BMW-roundel-white.37afc396.png";